<script lang="ts" setup>
const props = defineProps({
  message: {
    type: String,
    default: '',
  },
  iconAlert: {
    type: String,
    default: 'icon-alert',
  },
  className: {
    type: String,
    default: '',
  },
})
</script>
<template>
  <div class="warning-message" :class="className">
    <i :class="iconAlert" />
    <span v-if="message">{{ props.message }}</span>
    <slot name="message" />
  </div>
</template>
